import { AchievementCompleteRulePeriodUnion } from "types/achievements";

export const capitalizeFirstLetter = (string: string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

export const pluralizeUnit = (
  value?: number,
  singularUnitName: string = "",
  pluralUnitName: string = "",
) => (value ? `${value} ${value > 1 ? pluralUnitName : singularUnitName}` : "");

export const pickPluralizedUnit = (
  value: number,
  singularUnitName: string = "",
  pluralUnitName: string = "",
) => `${value! > 1 || value! === 0 ? pluralUnitName : singularUnitName}`;

export const getAcronym = (name: string): string => {
  if (!name) return "";
  const whiteSpaceRegex = new RegExp("/^s+$/");

  if (whiteSpaceRegex.test(name)) {
    return name.slice(0, 2);
  }

  return name
    .split(/\s/)
    .reduce((accumulator, word) => accumulator + word.charAt(0), "")
    .slice(0, 2)
    .toUpperCase();
};

export const pluralizeValueAdornment = (
  period?: AchievementCompleteRulePeriodUnion,
  amount?: number,
): string => {
  if (typeof amount !== "number") {
    return "";
  }

  switch (period) {
    case "day":
    case "last_day":
      return pickPluralizedUnit(amount, "day", "days");
    case "week":
      return pickPluralizedUnit(amount, "week", "weeks");
    case "month":
      return pickPluralizedUnit(amount, "month", "months");
    case "year":
      return pickPluralizedUnit(amount, "year", "years");
    default:
      return "";
  }
};

export const firstLetterToLowercase = (string: string) =>
  string.charAt(0).toLowerCase() + string.slice(1);

export const handleBooleanValue = (value: boolean) => (value ? "yes" : "no");

export const getStringValue = (v?: string, emptyValue = "-") => v || emptyValue;
